import { TagData } from '@src/application/modules/tag/shared/tag/serializedTagTypes';
import { MSG_NAME_TO_IFRAME, MSG_NAME_FROM_IFRAME } from './handleIframeMessage';
import { FsVariationToForce } from '@src/application/modules/flagship/type';
import { ForceTestTargetingAction } from '../tag/forceTestTargeting';

export type VisitorVariations = {
  variationId: string;
  variationGroupId: string;
  campaignId: string;
};

export type VisitorData = {
  visitorId: string;
  context: Record<string, string | number | boolean>;
  hasConsented: boolean;
};

export enum VisitorVariationUpdateParam {
  NewNavigation = 'newNavigation',
}

/**
 * All events posted to iframe
 */
export type EventDataToIframe =
  | PushTagDataEventData
  | EventHighlightNotFound
  | SegmentClickClosing
  | CollapseAssistant
  | FsUpdateVisitorAllocatedVariations
  | FsVisitorExposedVariations
  | FsHIT;

export type PushTagDataEventData = {
  name: MSG_NAME_TO_IFRAME.QaAssistantTagData;
  tagData: TagData;
};
export type EventHighlightNotFound = {
  name: MSG_NAME_TO_IFRAME.QaAssistantHighlightNotFound;
};
export type SegmentClickClosing = {
  name: MSG_NAME_TO_IFRAME.SegmentClickClosing;
};

export type FsUpdateVisitorAllocatedVariations = {
  name: MSG_NAME_TO_IFRAME.FsUpdateVisitorAllocatedVariation;
  value: Record<string, VisitorVariations>;
  param?: VisitorVariationUpdateParam;
  visitorData?: VisitorData;
};

export type FsVisitorExposedVariations = {
  name: MSG_NAME_TO_IFRAME.FsVisitorExposedVariation;
  value: Record<string, VisitorVariations>;
  param?: VisitorVariationUpdateParam;
};

export type FsHIT = {
  name: MSG_NAME_TO_IFRAME.FsHIT;
  value: Record<string, unknown>[];
};

export type VisitorAllocatedVariations = {
  name: MSG_NAME_TO_IFRAME;
  value: Record<string, VisitorVariations>;
};

/**
 * All events posted from iframe
 */
export type EventDataFromIframe =
  | ChangeVariationEventData
  | RemoveHighlight
  | AddHighlight
  | CollapseAssistant
  | RemoveTransactions
  | CloseAssistant
  | UpdateEventNotificationBadge
  | RefreshPage
  | FsApplyForcedVariations
  | FsResetForcedVariations
  | FsQaAssistantReady
  | QaAssistantPlatform
  | FsTriggerRender
  | ChangeTestEventData
  | ForceTestTargetingEventData
  | QaAssistantPlatformChoiceLoaded
  | CreateDiagnosticFile
  | FsVariationsForcedAllocation
  | FsVariationsForcedUnallocation
  | FsRemoveForcedVariation;

export type CloseAssistant = {
  name: MSG_NAME_FROM_IFRAME.QaAssistantClose;
};
export type ChangeVariationEventData = {
  name: MSG_NAME_FROM_IFRAME.QaAssistantChangeVariation;
  testId: number;
  value: number;
  shouldReload: boolean;
};

export type ChangeTestEventData = {
  name: MSG_NAME_FROM_IFRAME.QaAssistantChangeTest;
  testId: number;
  value: number;
};
export type RemoveHighlight = {
  name: MSG_NAME_FROM_IFRAME.QaAssistantRemoveHighlight;
  path?: string;
};
export type AddHighlight = {
  name: MSG_NAME_FROM_IFRAME.QaAssistantAddHighlight;
  path?: string;
};
export type CollapseAssistant = {
  name: MSG_NAME_FROM_IFRAME.QaAssistantCollapse | MSG_NAME_TO_IFRAME.QaAssistantCollapse;
  value: boolean;
};
export type RemoveTransactions = {
  name: MSG_NAME_FROM_IFRAME.QaAssistantRemoveTransactions;
};
export type UpdateEventNotificationBadge = {
  name: MSG_NAME_FROM_IFRAME.QaAssistantEventNotification;
  value: number;
};
export type RefreshPage = {
  name: MSG_NAME_FROM_IFRAME.QaAssistantEventRefreshPage;
};

export type FsApplyForcedVariations = {
  name: MSG_NAME_FROM_IFRAME.FsApplyForcedVariations;
  value: Record<string, FsVariationToForce>;
};

export type FsVariationsForcedAllocation = {
  name: MSG_NAME_FROM_IFRAME.FsVariationsForcedAllocation;
  value: Record<string, FsVariationToForce>;
};

export type FsVariationsForcedUnallocation = {
  name: MSG_NAME_FROM_IFRAME.FsVariationsForcedUnallocation;
  value: Record<string, FsVariationToForce>;
};

export type FsResetForcedVariations = {
  name: MSG_NAME_FROM_IFRAME.FsResetForcedVariations;
};

export type FsRemoveForcedVariation = {
  name: MSG_NAME_FROM_IFRAME.FsRemoveForcedVariation;
  value: string[];
};

export type FsQaAssistantReady = {
  name: MSG_NAME_FROM_IFRAME.FsQaAssistantReady;
};

export type QaAssistantPlatform = {
  name: MSG_NAME_FROM_IFRAME.QaAssistantPlatform;
  value: string;
};

export type QaAssistantPlatformChoiceLoaded = {
  name: MSG_NAME_FROM_IFRAME.QaAssistantPlatformChoiceLoaded;
};

export type FsTriggerRender = {
  name: MSG_NAME_FROM_IFRAME.FsTriggerRender;
};

export type ForceTestTargetingEventData = {
  name: MSG_NAME_FROM_IFRAME.QaAssistantEventForceTestTargeting;
  testId: number;
  action: ForceTestTargetingAction;
};

export type CreateDiagnosticFile = {
  name: MSG_NAME_FROM_IFRAME.QaAssistantCreateDiagnosticFile;
  userId: number;
  description: string;
};
